import {
    GET_TICKETS_REQUEST,
    GET_TICKETS_SUCCESS,
    GET_TICKETS_FAIL,
    GET_TICKET_DETAIL_REQUEST,
    GET_TICKET_DETAIL_SUCCESS,
    GET_TICKET_DETAIL_FAIL,
    CREATE_TICKET_REQUEST,
    CREATE_TICKET_SUCCESS,
    CREATE_TICKET_FAIL,
    UPDATE_TICKET_STATUS_REQUEST,
    UPDATE_TICKET_STATUS_SUCCESS,
    UPDATE_TICKET_STATUS_FAIL,
    ASSIGN_TICKET_REQUEST,
    ASSIGN_TICKET_SUCCESS,
    ASSIGN_TICKET_FAIL,
    ADD_TICKET_COMMENT_REQUEST,
    ADD_TICKET_COMMENT_SUCCESS,
    ADD_TICKET_COMMENT_FAIL,
    GET_TICKET_DASHBOARD_REQUEST,
    GET_TICKET_DASHBOARD_SUCCESS,
    GET_TICKET_DASHBOARD_FAIL,
    GET_MY_TICKETS_REQUEST,
    GET_MY_TICKETS_SUCCESS,
    GET_MY_TICKETS_FAIL,
} from "../constant";

const initialState = {
    tickets: [],
    ticketDetail: null,
    dashboard: null,
    myTickets: [],
    loading: false,
    detailLoading: false,
    dashboardLoading: false,
    creating: false,
    updating: false,
};

const ticketReducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_TICKETS_REQUEST:
            return { ...state, loading: true };
        case GET_TICKETS_SUCCESS:
            return { ...state, loading: false, tickets: action.payload };
        case GET_TICKETS_FAIL:
            return { ...state, loading: false, tickets: [] };

        case GET_TICKET_DETAIL_REQUEST:
            return { ...state, detailLoading: true, ticketDetail: null };
        case GET_TICKET_DETAIL_SUCCESS:
            return { ...state, detailLoading: false, ticketDetail: action.payload };
        case GET_TICKET_DETAIL_FAIL:
            return { ...state, detailLoading: false, ticketDetail: null };

        case CREATE_TICKET_REQUEST:
            return { ...state, creating: true };
        case CREATE_TICKET_SUCCESS:
            return { ...state, creating: false };
        case CREATE_TICKET_FAIL:
            return { ...state, creating: false };

        case UPDATE_TICKET_STATUS_REQUEST:
        case ASSIGN_TICKET_REQUEST:
        case ADD_TICKET_COMMENT_REQUEST:
            return { ...state, updating: true };
        case UPDATE_TICKET_STATUS_SUCCESS:
        case UPDATE_TICKET_STATUS_FAIL:
        case ASSIGN_TICKET_SUCCESS:
        case ASSIGN_TICKET_FAIL:
        case ADD_TICKET_COMMENT_SUCCESS:
        case ADD_TICKET_COMMENT_FAIL:
            return { ...state, updating: false };

        case GET_TICKET_DASHBOARD_REQUEST:
            return { ...state, dashboardLoading: true };
        case GET_TICKET_DASHBOARD_SUCCESS:
            return { ...state, dashboardLoading: false, dashboard: action.payload };
        case GET_TICKET_DASHBOARD_FAIL:
            return { ...state, dashboardLoading: false, dashboard: null };

        case GET_MY_TICKETS_REQUEST:
            return { ...state, loading: true };
        case GET_MY_TICKETS_SUCCESS:
            return { ...state, loading: false, myTickets: action.payload };
        case GET_MY_TICKETS_FAIL:
            return { ...state, loading: false, myTickets: [] };

        default:
            return state;
    }
};

export { ticketReducer };
